// extracted by mini-css-extract-plugin
var _1 = "HighlightedSearchText-moduleHighlightedSearchText__vG2kV";
export { _1 as "HighlightedSearchText" }
